import { render, staticRenderFns } from "./r-recipe-page.vue?vue&type=template&id=e40aae26"
import script from "./r-recipe-page.vue?vue&type=script&lang=js"
export * from "./r-recipe-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e40aae26')) {
      api.createRecord('e40aae26', component.options)
    } else {
      api.reload('e40aae26', component.options)
    }
    module.hot.accept("./r-recipe-page.vue?vue&type=template&id=e40aae26", function () {
      api.rerender('e40aae26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/recipe/r-recipe-page.vue"
export default component.exports